<img *ngIf="layerLegend.legendType === 'image'" [src]="layerLegend.legendImage">
<div *ngIf="layerLegend.legendType === 'svg'" [innerHtml]="layerLegend.svgContent">
</div>